import React from 'react';
import { TabPane } from '../TabPane';
import UserSummary from './UserSummary';
import AttributeSummary from './AttributeSummary';
import PrepingSummary from './PrepingSummary';
import DailyRestrictionSummary from './DailyRestrictionSummary';
import AnalysisSummary from './AnalysisSummary';

export const SummaryPane = ({ currentCaps, criteriaType }) => {
  return (
    <TabPane tabId='Summary'>
      <UserSummary />
      <AttributeSummary currentCaps={currentCaps} />
      <PrepingSummary />
      <DailyRestrictionSummary criteriaType={criteriaType} />
      <AnalysisSummary />
    </TabPane>
  );
};
